module.exports = __webpack_public_path__ + "static/media/banner1.3d74c6ba.jpg";